import requset from "utils/request";
import baseURL from '@/api/env.js'
/* 登录 */
export function login(params, type) {
  let url = ''
  if (type == 7) {
    url = '/user/third/auth/app/facebook'
  } else if (type == 8) {
    url = '/user/third/auth/login/google'
  } else {
    url = '/user/auth/login'
  }
  return requset({
    url: baseURL.AHEAD + url,
    method: "POST",
    params
  });
}
/* 登出 */
export function logout() {
  return requset({
    url: baseURL.AHEAD + "/user/auth/logout",
    method: "POST"
  });
}
/* 刷新Token */
export function authrefreshToken(params) {
  return requset({
    url: `${baseURL.AHEAD}/user/auth/refreshToken`,
    method: "POST",
    params
  });
}
/* 用户设置 */
// 获取用户信息
export function getuserInfo() {
  return requset({
    url: `${baseURL.AHEAD}/user/account/info`,
    method: "get"
  });
}

// 邮箱注册
export function getEmailRegister(params) {
  return requset({
    url: `${baseURL.AHEAD}/user/auth/register/email`,
    method: "POST",
    params
  });
};